// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oq-0";